import { addRemoveFavoriteDoctor, getDoctorList } from 'aster-foundation/core/teleconsultant/doctor/redux/actions';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import { IC_TICK } from '../../Assets/images';
import {
  getDoctorsListObject,
  sendCarouselClickEvent,
  sendListingPageviewEvent
} from '@common/Utility/analytics-utils';
import { doctorNameEncoder, errorHandling, URL_QUERY } from '@common/Utility/common-utils';
import { TELECONSULT_ROUTE } from '@common/Utility/constants';
import DoctorCard from '../DoctorCard/DoctorCard';
import { ToastControl } from '../Forms';
import SectionBox from '../SectionBox/SectionBox';
import SlickSlider from '../SlickSlider/SlickSlider';
import { NewDoctorStyled } from './NewDoctorStyled';
import { getDoctorListings } from '@common/Utility/insider-object-integration';
import Link from 'next/link';
import { MY_ASTER_CATEGORY, PAGE_NAME } from '../../Constants/analytics';
import { doctorCardClick } from '../BookAppointment/BookingFunnelAnalytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const responsive = [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 2,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 1.5,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
    },
  },
];

const NewDoctor = (props) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const t = useTranslation();
  const generateURL = useNavigationURL();
  const userLocation = useSelector((state) => state?.app?.userLocationReducer?.location);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);

  const [hideFavMessage, setHideFavMessage] = useState(true);
  const [favoriteMessage, setFavoriteMessage] = useState(null);
  const [newDoctorList, setNewDoctorList] = useState([]);

  const doctorDetails = (id, details) => {
    let mode = 'View more';
    if (sessionStorage.getItem('bookAppointmentLoginType')) {
      mode = sessionStorage.getItem('bookAppointmentLoginType');
    }
    sessionStorage.setItem('type', 'book');
    sessionStorage.setItem('referrerPage', 'Tele-consult Homepage');
    const path = JSON.stringify(router);
    sessionStorage.setItem('backPath', path);
    doctorCardClick(details, router?.asPath, props?.title);
    router.push({
      pathname: generateURL(`${TELECONSULT_ROUTE}/d/${doctorNameEncoder(details?.name).replace(URL_QUERY, '')}/${id}`),
    });
  };

  useEffect(() => {
    if (newDoctorList && newDoctorList?.length > 0) {
      const items = newDoctorList?.map((element, index) => {
        return {
          ...getDoctorsListObject(element),
          index: index + 1,
          taxonomy: ['Teleconsultation', element?.specialization],
          unit_price: 0,
          unit_sale_price: 0,
          stock: 1,
          url: `${location?.origin}${TELECONSULT_ROUTE}/d/${doctorNameEncoder(element?.name)?.replace(URL_QUERY, '')}/${
            element?.id
          }`,
          product_image_url: element?.profileURL,
          ...getDoctorListings(element),
        };
      });
    }
  }, [newDoctorList]);

  const newDoctorViewAll = () => {
    const doctorName = [];
    const doctorSpeciality = [];
    newDoctorList?.forEach((doctor) => {
      doctorName?.push(doctor?.name);
      doctorSpeciality.push(doctor?.specialization);
    });
    dataLayerSendEvent('new_doctors_view_all', {
      doctorsList: { doctorName, doctorSpeciality },
    });
  };

  const getuserLocationMemo = React.useMemo(() => {
    return userLocation;
  }, [userLocation?.lat, userLocation?.lng]);

  const getUserLoginMemo = React.useMemo(() => {
    return userLogin?.id;
  }, [userLogin?.id]);

  useEffect(() => {
    if (userLocation) {
      dispatch(
        getDoctorList({
          queryParam: {
            isNewDoctor: true,
            lat: userLocation.lat,
            long: userLocation.lng,
          },
          onSuccess: (response) => {
            setNewDoctorList(response?.data);
          },
          onFailure: (err) => {
            errorHandling(err);
          },
        }),
      );
    }
  }, [getuserLocationMemo, favoriteMessage]);

  const addRemoveDoctorFromFavorites = (id, flag, item) => {
    if (flag && id) {
      removeFavDoctor(id, false, item);
    } else {
      dispatch(
        addRemoveFavoriteDoctor({
          doctorId: id,
          isAddDoctor: !flag,
          onSuccess: (response) => {
            setFavoriteMessage(response);
            setHideFavMessage(true);
            const itemData = {
              doctor_name: item?.name,
              speciality: item?.specialization,
              hospital_name: item?.facility,
              _clear: true,
            };
            dataLayerSendEvent('new_doctor_add_favourite', itemData);
          },
          onFailure: (err) => {
            errorHandling(err);
          },
        }),
      );
    }
  };

  const removeFavDoctor = (id, flag, item) => {
    dispatch(
      addRemoveFavoriteDoctor({
        doctorId: id,
        isAddDoctor: flag,
        onSuccess: (response) => {
          setFavoriteMessage(response);
          setHideFavMessage(true);
          const itemData = {
            doctor_name: item?.name,
            speciality: item?.specialization,
            hospital_name: item?.facility,
            _clear: true,
          };
          dataLayerSendEvent('new_doctor_remove_favourite', itemData);
        },
        onFailure: (err) => {
          errorHandling(err);
        },
      }),
    );
  };

  useEffect(() => {
    if (favoriteMessage) {
      setTimeout(() => {
        setHideFavMessage(false);
        setFavoriteMessage(null);
      }, 4000);
    }
  }, [favoriteMessage]);

  return (
    <NewDoctorStyled>
      {favoriteMessage && hideFavMessage && (
        <ToastControl
          className={`${scrollY > 38 ? 'toast-fixed' : ''}`}
          imgBox={true}
          imgError={IC_TICK}
          variant={'green-dark-box floating-wrapper toast-image'}
          text={favoriteMessage}
        ></ToastControl>
      )}
      {newDoctorList !== undefined && newDoctorList?.length !== 0 && (
        <SectionBox
          customOuterClass="newDoctorSection mb-3"
          title={'New Doctors'}
          rightTop={
            newDoctorList?.length > 3 ? (
              <Link href={{ pathname: generateURL(`${TELECONSULT_ROUTE}/doctors`), query: { type: 'newDoctor' } }} passHref>
              <a
              className="link cursor-pointer"
                onClick={() => {
                  dataLayerSendEvent('new_doctors_view_all');
                  sendListingPageviewEvent(
                    'new doctor listing',
                    MY_ASTER_CATEGORY.DOCTOR_CONSULT,
                    PAGE_NAME.DLP,
                    PAGE_NAME.TC_HOME,
                    '',
                    newDoctorList?.length,
                  );
                  newDoctorViewAll();
                }}
              >
                {t('EPharmacyHome.viewAll')}
              </a>
              </Link>
            ) : (
              <></>
            )
          }
        >
          <SlickSlider
            sliderSettings={{
              responsive: responsive,
              slidesToShow: 2.9,
              infinite: false,
              className: 'myDoctorSlider',
              dots: false,
            }}
          >
            {newDoctorList?.map((item) => {
              return (
                <Link href={generateURL(`${TELECONSULT_ROUTE}/d/${doctorNameEncoder(item?.name).replace(URL_QUERY, '')}/${item?.id}`)}>
                <a>
                <DoctorCard
                  cardlabel="Book Appointment"
                  image={item?.profileImageWeb}
                  cardvariant="primary-outlined card-btn-width"
                  name={item?.name}
                  specialist={item?.specialization}
                  consultation={
                    item?.consultation[0] === 'offline' || item?.consultation[1] === 'offline'
                      ? 'In-Person Consultation'
                      : ''
                  }
                  consulttype={
                    item?.consultation[0] === 'online' || item?.consultation[1] === 'online' ? 'Video Consultation' : ''
                  }
                  location={item?.facilityDetails?.[0]?.facilityName}
                  distance={item?.facilityDetails?.[0]?.distance ? item?.facilityDetails?.[0]?.distance : 'N/A'}
                  more={item?.facility?.length <= 1 ? '' : item?.facility?.length - 1 + ` more`}
                  availableTime={
                    item?.facilityDetails?.[0]?.nextAvailableAt && item?.facilityDetails?.[0]?.nextAvailableAt !== null
                      ? item?.facilityDetails?.[0]?.nextAvailableAt
                      : item?.nextAvailableAt
                  }
                  doctorDetails={() => doctorDetails(item?.id, item)}
                  checked={item?.isFavorite}
                  isGuest={props?.guest}
                  addRemoveFavorites={() => addRemoveDoctorFromFavorites(item.id, item?.isFavorite, item)}
                  languageText={item?.languages ? item?.languages.map((val) => val).join(', ') : ''}
                  availableOfflineSlot={item?.facilityDetails?.[0]?.availableOfflineSlot}
                  availableOnlineSlot={item?.availableOnlineSlot}
                  showNearestSlot={true}
                  outerCustomClass="doctorDetailCentered"
                  setLoading={props?.setLoading}
                />
                 </a>
                 </Link>
              );
            })}
          </SlickSlider>
        </SectionBox>
      )}
    </NewDoctorStyled>
  );
};

NewDoctor.propTypes = {
  data: PropTypes.any,
  guest: PropTypes.bool,
  addRemoveFavorites: PropTypes.func,
  setLoading: PropTypes.any,
  referrerPage: PropTypes.string,
  title: PropTypes.string,
};
export default NewDoctor;
